import { Link } from '@tanstack/react-router'
import { Phone, Mail } from 'lucide-react'
import { useLocale } from '@/lib/locale'
import { QATAR_BRAND, QatarMark } from './brand'
import { useQatarCopy } from './copy'

/** Footer for the Qatar face: bank mark, fraud line, "Powered by GranGuard". */
export default function QatarFooter() {
  const c = useQatarCopy()
  const locale = useLocale()
  return (
    <footer className="bg-[var(--qa-footer)] text-white">
      <div className="h-1 w-full bg-gradient-to-r from-[var(--qa-accent)] via-[var(--qa-accent-soft)] to-[var(--qa-accent)]" />
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <QatarMark onDark className="h-9" />
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-base text-white/80">
            <a
              href={`tel:${QATAR_BRAND.fraudLine.tel}`}
              className="inline-flex items-center gap-2 hover:text-white"
            >
              <Phone className="h-4 w-4 text-[var(--qa-accent-soft)]" />
              <span>
                {c.footerFraudLine}: <span dir="ltr">{QATAR_BRAND.fraudLine.display}</span>
              </span>
            </a>
            <a href={`mailto:${QATAR_BRAND.fraudEmail}`} className="inline-flex items-center gap-2 hover:text-white">
              <Mail className="h-4 w-4 text-[var(--qa-accent-soft)]" />
              <span dir="ltr">{QATAR_BRAND.fraudEmail}</span>
            </a>
          </div>
        </div>
        <div className="mt-8 flex flex-col gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-white/55">
            &copy; {new Date().getFullYear()} {QATAR_BRAND.legalName[locale]}. {c.footerLegal}
          </p>
          <div className="flex items-center gap-5 text-sm text-white/65">
            <Link to="/privacy" className="hover:text-white">
              {c.footerPrivacy}
            </Link>
            <Link to="/about" className="hover:text-white">
              {c.footerAbout}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
